export default __webpack_public_path__ + "d8c0dc915e2b23bc855a56c553734fe8.ico";